var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","full-width":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"headline"},[_vm._v(" "+_vm._s(this.$route.name))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }